import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ProcessingBar2 from "../../../../components/ProcessingBar/ProcessingBar2";
import ProcessingBarBlack from "../../../../components/ProcessingBar/ProcessingBlack";

const FifthSpaMassage = () => {
  const navigate = useNavigate();
  const [showProcessing, setShowProcessing] = useState(false);
  const [showProcessingCall, setShowProcessingCall] = useState(false);

  const handleregister = () => {
    setShowProcessing(true);
    setTimeout(() => {
      setShowProcessing(false); // (optional: hide after processing)
      navigate("/register");
    }, 2000);
  };

  const handleBookACall = () => {
    setShowProcessingCall(true);
    setTimeout(() => {
      setShowProcessingCall(false);
      navigate("/contact/book-a-call");
    }, 2000);
  };
  return (
    <div className="bg-dry py-20 px-4 text-white text-center border-b border-border">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-semibold mb-6 leading-snug">
          Ready to try Lokalai for your Spa and Massage?
        </h2>
        <p className="text-md text-[#F1EAEA] mb-12">
          30-day free trial. No card. No commitment.
        </p>

        <div className="flex flex-row sm:flex-row items-start justify-center sm:items-center gap-4">
          <button
            onClick={handleregister}
            className="bg-redlight text-text px-6 py-3 rounded-full font-semibold text-sm transition-transform duration-200 hover:scale-105 w-[200px] h-[45px]"
          >
            {showProcessing ? (
              <div className="flex items-center justify-center w-full h-full">
                <ProcessingBar2 />
              </div>
            ) : (
              "Start your free trial"
            )}
          </button>

          <button
            onClick={handleBookACall}
            className="relative text-text text-sm font-semibold pb-1 after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-full after:bg-text after:transition-all after:duration-200 hover:after:w-0 min-w-[100px] h-[40px] flex items-center justify-center"
          >
            {showProcessingCall ? <ProcessingBarBlack /> : "Talk to us"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FifthSpaMassage;
